export enum AiEngineDataType {
  HomeRecommendedForYou,
  HomeYouMayHaveMissed,
  MoreOnThisTopic,
  MyNewsFresh,
  OnBoard,
  TopPicks,
  Section,
  MyNewsHot,
}

export enum OnBoardingType {
  Conversations = "a_c",
  EvergreenArticles = "eg",
  FollowSubscription = "t_aut",
  MyNews = "t",
  RecommendedArticles = "a",
}
